// extracted by mini-css-extract-plugin
module.exports = {"VariantsLabels":"styles_VariantsLabels__U0105","visible":"styles_visible__G0nE_","label":"styles_label__yg0dM","available":"styles_available__HoioV"};